export default {"src":"/_next/static/media/login.ac97fe44.svg","height":20,"width":21};